<div class="center-xs custom_modal">
  <div class="modal-body">
    <div
      class="modal-status"
      [ngClass]="data.type"
    >
      <i
        class="fa fa-check-circle-o"
        *ngIf="data.type === 'success'"
      ></i>
      <i
        class="fa fa-exclamation-triangle"
        *ngIf="data.type === 'error' || data.type === 'warning'"
      ></i>
      <i
        class="fa fa-info"
        *ngIf="data.type === 'info'"
      ></i>
      {{ data.title || ('SHARED.MODAL.' + data.titleCode | translate) }}
    </div>
    <div>
      <span
        *ngIf="data.messageCode"
        [innerHTML]="data.messageCode | translate : params"
      ></span>
      <span
        *ngIf="data.message"
        [innerHTML]="data.message"
      ></span>
      <span
        *ngIf="data.timeToDoAction"
        class="time-to-do-action"
        >{{ (timeToDoAction$ | async) || data.timeToDoAction }}</span
      >
      <ul class="subMessages">
        <li *ngFor="let subMessage of data.subMessages">{{ subMessage }}</li>
      </ul>
    </div>
  </div>

  <div class="modal-buttons">
    <eps-button
      (buttonClick)="close()"
      [label]="data.buttonText"
      *ngIf="!data.disableClose"
    ></eps-button>
    <eps-button
      (buttonClick)="extendSession()"
      label="SHARED.BUTTONS.EXTEND_SESSION"
      *ngIf="data.showExtendSession"
    ></eps-button>
    <eps-button
      (buttonClick)="logout()"
      [label]="data.buttonText"
      *ngIf="data.showLogout"
    ></eps-button>
    <eps-button
      label="SHARED.BUTTONS.COPY_TO_CLIPBOARD"
      ngxClipboard
      [cbContent]="data.copyToClipboard"
      [disabled]="isCopied"
      [buttonIcon]="isCopied ? 'check' : 'clipboard'"
      (buttonClick)="isCopied = true"
      *ngIf="data.copyToClipboard"
    ></eps-button>
  </div>
</div>
